import { render, staticRenderFns } from "./InputTextWithSuggestions.vue?vue&type=template&id=0ac0518e"
import script from "./InputTextWithSuggestions.vue?vue&type=script&lang=js"
export * from "./InputTextWithSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports